// src/app/modules/ThreatAlerts/database/column-formatters/SeverityColumnFormatter.jsx
import React from "react";

const SEVERITY_CONFIG = {
  critical: { pill: 'sety-pill-red' },
  high:     { pill: 'sety-pill-amber' },
  medium:   { pill: 'sety-pill-purple' },
  low:      { pill: 'sety-pill-green' },
};

export function SeverityColumnFormatter(cellContent, row) {
  const config = SEVERITY_CONFIG[row.severity] || { pill: 'sety-pill-grey' };
  return (
    <span className={`sety-pill ${config.pill}`}>
      {row.severity?.toUpperCase()}
    </span>
  );
}
